import { render, staticRenderFns } from "./MyBuyWorkList.vue?vue&type=template&id=7fab1340&scoped=true&"
import script from "./MyBuyWorkList.vue?vue&type=script&lang=js&"
export * from "./MyBuyWorkList.vue?vue&type=script&lang=js&"
import style0 from "./MyBuyWorkList.vue?vue&type=style&index=0&id=7fab1340&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab1340",
  null
  
)

export default component.exports